export default __webpack_public_path__ + "static/acropolis-991dc7334fc0159b9810b947de69e20c.png";